export default __webpack_public_path__ + "static/media/googledrive-logo.3d7aff58.png";